<!-- Hidden native input (screen reader still okay because drag area is the main control) -->
<input
  #fileInput
  type="file"
  [multiple]="multiple"
  class="file-input-native"
  (change)="onFilesSelected($event)"
  aria-hidden="true"
/>

<!-- Drag & drop + click area -->
<div
  class="file-input-dropzone"
  (click)="triggerFileDialog()"
  (keydown.enter)="triggerFileDialog()"
  (keydown.space)="triggerFileDialog()"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  tabindex="0"
  role="button"
  [attr.aria-label]="multiple ? 'Dateien hier ablegen oder Enter drücken, um Dateien auszuwählen' : 'Datei hier ablegen oder Enter drücken, um die Datei auszuwählen'"
>
  <div class="dropzone-content">
    <button
      [matButton]="files.length > 0 ? 'outlined' : 'filled'"
      type="button"
      (click)="$event.stopPropagation(); triggerFileDialog()"
      aria-label="{{ placeholder }}"
    >
      @if (!files.length) {
        <mat-icon data-qa="file-upload-button-icon-upload" fontIcon="queue"></mat-icon>
      }
      @if (files.length > 0) {
        <mat-icon data-qa="file-upload-button-icon-success" fontIcon="check_circle_outline"></mat-icon>
      }
      @if (true) {
        <span data-qa="file-upload-button-message-upload" >{{ placeholder }}</span>
      }
    </button>

    <span class="drop-hint">
      Wählen Sie eine Datei aus oder ziehen Sie die gewünschte Datei in den markierten Bereich.
    </span>
  </div>
</div>

<!-- Single file shows file name prominently, multiple shows list -->
@if (files.length > 0) {
  @if (multiple) {
    <!-- Multiple file list -->
    <div class="file-input-actions">
      <button matButton="outlined" type="button" (click)="clearAll(); markTouched()">
        <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        Alle ({{ files.length }}) entfernen
      </button>
    </div>

    <ul class="file-list" aria-label="Dateien auswählen">
      @for (file of files; track file.name; let i = $index) {
        <li class="file-list-item">
          <div class="file-main">
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size">{{ file.size / 1024 | number : '1.0-0' }} KB</span>
          </div>
          <button
            matButton="outlined"
            type="button"
            (click)="removeFile(i); markTouched()"
            [attr.aria-label]="'Entferne Datei ' + getFileDescription(file)"
          >
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Entfernen
          </button>
        </li>
      }
    </ul>
  } @else {
    <div class="file-input-actions">
      <div class="single-file-display">
        <span class="file-name-primary">{{ files[0].name }}</span>
        <span class="file-size">{{ files[0].size / 1024 | number : '1.0-0' }} KB</span>
      </div>
      <button matButton="outlined" type="button" (click)="clearAll(); markTouched()">
        <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        Entfernen
      </button>
    </div>
  }
}

<ng-content></ng-content>
